import { MyOrderStatusVariant } from 'entities/common/my-ticket/model/types'

const INSURANCE_STATUSES: Record<string, MyOrderStatusVariant> = {
  CONFIRMED: {
    name: 'my_orders_block.insurance.status.confirmed',
    color: '#129958',
    background: '#eef8f4',
  },
  CREATED: {
    name: 'my_orders_block.insurance.status.created',
    color: '#fa7207',
    background: '#fff1e6',
  },
  CANCELLED: {
    name: 'my_orders_block.insurance.status.cancelled',
    color: '#ec1212',
    background: '#feeded',
  },
  PENDING_CONFIRMATION: {
    name: 'my_orders_block.insurance.status.pending_confirmation',
    color: 'rgba(250, 114, 7, 1)',
    background: 'rgba(255, 249, 217, 1)',
  },
}

const PENDING_INSURANCE_STATUS: MyOrderStatusVariant = {
  name: 'status_names.pending',
  color: 'rgba(250, 114, 7, 1)',
  background: 'rgba(255, 249, 217, 1)',
}

export const getInsuranceStatus = (status: string): MyOrderStatusVariant =>
  INSURANCE_STATUSES[status] || PENDING_INSURANCE_STATUS
